export default __webpack_public_path__ + "static/media/Emoji_Bar_Yuuck.c40e6123.svg";